module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg@2x.aad2d85d.png";